import { useEffect } from 'react';

import { useLocation } from 'react-router';

import { useConsentManager } from '@c15t/react';

import { gtmService } from '@/services/GTMService';

export const GTMPageViewTracker = () => {
  const { pathname } = useLocation();
  const { has } = useConsentManager();
  const hasMeasurementConsent = has('measurement');

  useEffect(() => {
    if (!gtmService.isGtmAvailable) {
      return;
    }
    gtmService.trackPageView(pathname, hasMeasurementConsent);
  }, [pathname, hasMeasurementConsent]);

  return <></>;
};
